import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import ThankYouPage from "@/pages/ThankYouPage";
import LeadFormModal from "@/components/landing/LeadFormModal";
import { LeadModalProvider } from "@/context/LeadModalContext";
import { captureAttribution } from "@/lib/attribution";

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <div className="App">
      <LeadModalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
          </Routes>
          <LeadFormModal />
        </BrowserRouter>
      </LeadModalProvider>
    </div>
  );
}

export default App;
